/* import __COLOCATED_TEMPLATE__ from './powered-by.hbs'; */
/* RESPONSIBLE TEAM: team-channels */
import Component from '@glimmer/component';
import type Store from '@ember-data/store';
import type IntlService from 'embercom/services/intl';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { enqueueTask } from 'ember-concurrency-decorators';
import type { TaskGenerator } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';

interface Args {
  settings: $TSFixMe;
}

export default class PoweredBy extends Component<Args> {
  @service declare store: Store;
  @service declare notificationsService: $TSFixMe;
  @service declare intl: IntlService;
  @service declare intercomEventService: $TSFixMe;

  @enqueueTask
  *updateSetting(): TaskGenerator<void> {
    try {
      yield this.args.settings.save();

      this.trackUpdateAnalytics();

      this.notificationsService.notifyConfirmation(
        this.intl.t('channels.email.settings.update_success'),
      );
    } catch (error) {
      this.args.settings.toggleProperty('emailPoweredBy');
      this.notificationsService.notifyResponseError(error, {
        default: this.intl.t('channels.email.settings.update_failure'),
      });
    }
  }

  @action
  togglePoweredBySettings() {
    this.args.settings.toggleProperty('emailPoweredBy');
    taskFor(this.updateSetting).perform();
  }

  trackUpdateAnalytics() {
    let action = this.args.settings.emailPoweredBy ? 'turned_on' : 'turned_off';
    this.trackAnalytics(action);
  }

  trackAnalytics(action: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action,
      object: 'powered_by_settings',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Channels::Email::Advanced::PoweredBy': typeof PoweredBy;
  }
}
